module.exports = __webpack_public_path__ + "img/11b.930e70e6.jpg";